<template>
  <div class="created">
    <el-button type="text" size="medium" @click="$router.go(-1)">返回</el-button>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="添加课程" prop="name">
        <el-col :span="24">
          <div class="toptitle training">
            <el-input v-model="ruleForm.name" placeholder=" 请选择体验营课程" maxlength="20" show-word-limit
              :readonly="true"></el-input>
            <el-button type="primary" @click="addcourseHandel()" :disabled="isShow">查询</el-button>
          </div>
        </el-col>
      </el-form-item>
      <el-form-item label="价格">
        <el-col :span="8">
            <div class="block">
              <el-input  v-model="ruleForm.price" placeholder=" 请输入金额"
              show-word-limit :readonly="true"></el-input>元
            </div>
        </el-col>
      </el-form-item>
      <el-form-item label="分润金额" prop="rebate_amount">
        <el-col :span="11">
          <div class="block">
            <el-input v-model="ruleForm.rebate_amount" placeholder=" 请输入分润金额" show-word-limit type="number"></el-input>元
            （分润金额必须是整数）
          </div>
        </el-col>
      </el-form-item>
      <el-form-item label="分享海报" class="is-required">
        <el-col :span="10">
          <activityCustomUpload :formName="'share_img_url'" :formValue="ruleForm.share_img_url"
            @uploadSuccess="uploadSuccess">
          </activityCustomUpload>
        </el-col>
      </el-form-item>
      <el-form-item label="客服二维码" class="is-required">
        <el-col :span="10">
          <activityCustomUpload :formName="'custom_service_url'" :formValue="ruleForm.custom_service_url"
            @uploadSuccess="uploadSuccess">
          </activityCustomUpload>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button @click="resetForm('ruleForm')">取消</el-button>
      </el-form-item>
    </el-form>
    <el-dialog title="选择商品" :visible.sync="chooseOrgVisible" :close-on-click-modal="true"
      :before-close="addEditFormOnClose" width="75%">
      <el-form :inline="true" :model="search.query">
        <el-form-item>
          <el-input size="small" v-model="search.query.search" placeholder="请输入标题" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="searchData">
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <el-table border :data="result_data" highlight-current-row v-loading="loading1">
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column prop="title" label="标题" align="center"></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="selectProduct(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @current-change="currentHandel" :current-page.sync="search.query.page"
        :page-size="search.query.limit" layout="prev, pager, next" :total="search.total">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import { screenProductList } from "@/api/coupon";
import { createUpdateRelation, getRelationshipDetail } from "@/api/distribution"
export default {
  components: { activityCustomUpload, },
  data() {
    return {
      ruleForm: {
        activity_distribution_id: this.$route.query.id,
        id: null,
        target_id: '',
        name: '',
        price:'',
        rebate_amount: null,
        share_img_url: '',
        custom_service_url: '',
      },
      rules: {
        name: [
          { required: true, message: '请选择体验营课程', trigger: 'blur' },
          { min: 0, max: 20, message: '长度在0-20个字符', trigger: 'blur' }
        ],
        rebate_amount: [
          { required: true, message: '请输入分润金额', trigger: 'change' }
        ],
      },
      search: {
        query: {
          type: 1,
          search: "",
          page: 1,
          limit: 5,
          target_type: 19,
        },
        total: 0,
      },
      chooseOrgVisible: false,
      result_data: [],
      loading1: true,
      rowid: null,
      isShow:false
    };
  },
  mounted() {
    this.rowid = this.$route.query.rowid
    if(this.rowid){this.isShow = true}
    console.log(this.rowid);
    if (this.rowid) {
      this.getDetail()
    } else {
      return
    }
  },
  methods: {
    submitForm(formName) { // 表单提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.share_img_url) { this.$message({ message: "请上传分享海报", type: "error", }); return; }
          if (!this.ruleForm.custom_service_url) { this.$message({ message: "请上传客服二维码", type: "error", }); return; }
          console.log(Number.isInteger(1),Number(this.ruleForm.rebate_amount),'++++++++++');
          let fenrunprice = Number(this.ruleForm.rebate_amount)
          if (!Number.isInteger(fenrunprice)) {
             this.$message({ message: "分润金额必须是整数", type: "error", });
              return;
             }
          createUpdateRelation(this.ruleForm).then((res) => {
            if (res.code) {

              this.$message({
                message: '操作成功',
                type: 'success'
              });
this.$router.go(-1)
            } else {
              return
            }
          })
          console.log(this.ruleForm);
        } else {
          return false;
        }
      });
    },
    resetForm(formName) { // 验证
      this.$router.go(-1)
    },
    uploadSuccess(value) { // tu片上传
      console.log(value, '1111');
      const fileExtension = value.fileUrl.split('.').pop().toLowerCase();

      // 判断是否是图片格式
      const isImageFormat = ['png', 'jpeg', 'jpg', 'gif', ''].includes(fileExtension);

      if (isImageFormat) {
        // console.log('是图片格式');
        this.ruleForm[value.formName] = this.rules[value.formName] = value.fileUrl
        this.$refs.ruleForm.validateField(value.formName);
      } else {
        this.$message({
          message: '请上传图片格式文件',
          type: 'error'
        });
        return
      }


    },
    getTYYlist() { // 体验营课程列表
      screenProductList(this.search.query).then((res) => {
        console.log(res);
        this.result_data = res.data.list
        this.search.total = res.data.total
        this.loading1 = false
      })
    },
    addcourseHandel() { //查询体验营课程
      this.chooseOrgVisible = true
      this.getTYYlist()
    },
    searchData() { // 模糊查询
      this.getTYYlist()
    },
    addEditFormOnClose() {
      this.chooseOrgVisible = false
      this.search.query.search = ''
    },
    currentHandel(currentPage) { // 页码改变
      this.search.query.page = currentPage
      this.getTYYlist()
    },
    selectProduct(row) { // 选择课程
      console.log(row);
      this.ruleForm.name = row.title
      this.ruleForm.target_id = row.id
      this.chooseOrgVisible = false
      this.ruleForm.price = row.price
    },
    getDetail() {
      getRelationshipDetail({ activity_distribution_id: this.ruleForm.activity_distribution_id, id: this.rowid }).then((res) => {
        if(res.code){
          this.ruleForm.name = res.data.target_info.title
          this.ruleForm.price = res.data.target_info.price
          this.ruleForm.share_img_url = res.data.share_img_url
          this.ruleForm.rebate_amount = res.data.rebate_amount
          this.ruleForm.custom_service_url = res.data.custom_service_url
          this.ruleForm.target_id = res.data.target_id
          this.ruleForm.id = this.rowid
        }
      })
    },
  }
}
</script>

<style>
.created {
  padding: 20px;
}

.created .el-input {
  width: 300px;
  margin-right: 10px;
}
</style>